// extracted by mini-css-extract-plugin
export default {"root":"rOSWw","header":"vrcv4","content":"vysUZ","mobile":"EryRF"};